import React, { useEffect, useState } from 'react';
import { Button } from '@attentive-platform/stem-ui';

import { TatConsoleStyles as S } from './styles';

const RemoveCustomCardModal = ({
  open,
  tradeName,
  returnCardName,
  actorName,
  submitting,
  onCancel,
  onConfirm
}) => {
  const [reason, setReason] = useState('');

  useEffect(() => {
    if (open) setReason('');
  }, [open]);

  if (!open) return null;

  const disabled = !(reason || '').trim() || !!submitting;
  const title = `Remove the custom card for ${tradeName}?`;
  const body = `The account returns to ${returnCardName || '—'}. This mints a version labelled "Custom card removed by ${actorName}". No customer email is sent.`;

  return (
    <>
      <S.Overlay onClick={submitting ? undefined : onCancel} />
      <S.ModalSm role='dialog' aria-modal='true' aria-label='Remove the custom card'>
        <S.ModalTitle>{title}</S.ModalTitle>
        <span style={{ fontSize: '13.5px', lineHeight: 1.6, color: '#4D4D4D' }}>{body}</span>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
          <S.FieldLabel>
            Reason <S.Req>(required)</S.Req>
          </S.FieldLabel>
          <S.TextArea
            value={reason}
            onChange={e => setReason(e.target.value)}
            rows={2}
            disabled={!!submitting}
          />
        </div>
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, paddingTop: 4 }}>
          <Button variant='text' color='primary' size='large' onClick={onCancel} disabled={!!submitting}>
            Keep it
          </Button>
          <Button
            variant='contained'
            color='primary'
            size='large'
            disabled={disabled}
            onClick={() => {
              if (disabled) return;
              onConfirm(reason.trim());
            }}>
            {submitting ? 'Removing…' : 'Remove custom card'}
          </Button>
        </div>
      </S.ModalSm>
    </>
  );
};

export default RemoveCustomCardModal;
